/*
 * Copyright (c) 2020, WSO2 Inc. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 Inc. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import {
    USER_LOGIN_REQUEST, USER_LOGIN_SUCCESS, USER_LOGIN_FAILURE, REQUIRE_LOGIN,
    USER_INFO_REQUEST, USER_INFO_SUCCESS, USER_INFO_FAILURE,
    USER_ORG_INFO_REQUEST, USER_ORG_INFO_SUCCESS, USER_ORG_INFO_FAILURE,
    CHANGE_ORG_REQUEST, CHANGE_ORG_SUCCESS, CHANGE_ORG_FAILURE, UserActions,
    OBTAIN_APIM_TOKEN_FAILURE, OBTAIN_APIM_TOKEN_SUCCESS, OBTAIN_APIM_TOKEN_REQUEST,
    ADD_ENTERPRISE_USER_REQUEST, ADD_ENTERPRISE_USER_SUCCESS, ADD_ENTERPRISE_USER_FAILURE
} from '../types/user';

const initialState = {
    loading: false,
    user: {},
    userInfo: {},
    orgs: [],
    selectedOrg: {},
    error: '',
    signedIn: false,
    apimTokenObtained: false,
    apimTokenObtaining: false,
    requireLogin: false,
    status: 0,
}

const userReducer = (state = initialState, action: UserActions) => {
    switch (action.type) {
        case USER_LOGIN_REQUEST:
            return {
                ...state,
                loading: true,
                user: {},
                error: '',
                signedIn: false,
                apimTokenObtained: false,
                apimTokenObtaining: false,
            }
        case USER_LOGIN_SUCCESS:
            return {
                ...state,
                loading: false,
                user: action.payload,
                error: '',
                signedIn: true,
            }
        case USER_LOGIN_FAILURE:
            return {
                ...state,
                loading: false,
                user: {},
                error: action.payload,
                signedIn: false
            }
        case REQUIRE_LOGIN:
            return {
                ...state,
                loading: true,
                requireLogin: true,
            }
        case USER_INFO_REQUEST:
            return {
                ...state,
                loading: true,
            }
        case USER_INFO_SUCCESS:
            return {
                ...state,
                userInfo: action.payload
            }
        case USER_INFO_FAILURE:
            return {
                ...state,
                error: action.payload
            }
        case USER_ORG_INFO_REQUEST:
            return {
                ...state,
                loading: true
            }
        case USER_ORG_INFO_SUCCESS:
            return {
                ...state,
                loading: false,
                orgs: action.payload,
                status: action.status
            }
        case USER_ORG_INFO_FAILURE:
            return {
                ...state,
                loading: false,
                orgs: [],
                error: action.payload
            }
        case CHANGE_ORG_REQUEST:
            return {
                ...state,
                loading: true
            }
        case CHANGE_ORG_SUCCESS: {
            return {
                ...state,
                loading: false,
                selectedOrg: action.payload
            }
        }
        case CHANGE_ORG_FAILURE: {
            return {
                ...state,
                loading: false,
                selectedOrg: undefined,
                error: action.payload
            }
        }
        case OBTAIN_APIM_TOKEN_REQUEST:
            return {
                ...state,
                loading: true,
                apimTokenObtained: false,
                apimTokenObtaining: true,
            }
        case OBTAIN_APIM_TOKEN_SUCCESS: {
            return {
                ...state,
                loading: false,
                apimTokenObtained: true,
                apimTokenObtaining: false,
                user: action.payload
            }
        }
        case OBTAIN_APIM_TOKEN_FAILURE: {
            return {
                ...state,
                loading: false,
                apimTokenObtained: false,
                apimTokenObtaining: false,
                error: action.payload
            }
        }
        case ADD_ENTERPRISE_USER_REQUEST: {
            return {
                ...state,
                loading: true,
                error: ''
            }
        }
        case ADD_ENTERPRISE_USER_SUCCESS: {
            return {
                ...state,
                loading: false,
                orgs: action.payload,
                error: ''
            }
        }
        case ADD_ENTERPRISE_USER_FAILURE: {
            return {
                ...state,
                loading: false,
                error: action.payload
            }
        }
        default:
            return state
    }
}

export default userReducer;
